import React,{Component} from "react";


import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';


import {  Row, Col, Card, CardHeader, CardBody, Button,

  Form,
  FormGroup,
  FormInput,
  
   ListGroup,
  ListGroupItem,
   } from "shards-react";



export default class ModifyResult extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
        name:undefined,
        roll_no:undefined,
        subjects:[],
        loading:false,
        //subjects
    };
    this.set_results_data = this.set_results_data.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.get_subject_marks = this.get_subject_marks.bind(this);
  }

  componentDidMount(){
      console.log(this.props);
      this.set_results_data();
  }



  set_results_data = () =>{
      var roll_no = this.props.data.roll_no;
      var result_data = this.props.data.result_data;
      for(var i=0;i<result_data.length;i++){
          if(result_data[i].roll_no===roll_no){
              this.setState({name:result_data[i].name,roll_no:result_data[i].roll_no,subjects:this.props.data.subject_list,index:i});
              this.setState(result_data[i].subjects);
          }
      }
  }

  update_data = (evt)=>{
      evt.preventDefault();
      var result_data = this.props.data.result_data;

      this.setState({loading:true});
      var subjects = {};
      var state_data = this.state;

      this.state.subjects.forEach(function(subject_d){
          var subject_name = subject_d.subjectname;
          subjects[subject_name] = state_data[subject_name];

          if(subjects[subject_name]==="" || subjects[subject_name]===undefined){
              subjects[subject_name] = null;
          }
      })

      var data = {
        name : this.props.data.name,
        roll_no : this.props.data.roll_no,
        subjects :subjects,
      }
      console.log(data.subjects); 
      result_data[this.state.index] = data;
      console.log(result_data[this.state.index]);
      console.log(result_data);
      var code = this.props.data.exam_name+":"+this.props.data.class_name;
      var that = this;
      that.setState({loading:false});
      firebase.firestore().collection('Results').doc(code).update({results:result_data}).then(function(doc){
          toast("Update Data Successfull",{containerID:'A'});
          console.log("Update succesfull");
          that.props.refresh();
          that.props.cancel();
          that.setState({loading:false});
      }).catch(function(err){
          console.log(err);
          that.setState({loading:false});
      })
  }

 
    changeHandler = (subject_name,marks)=>{

        var data = {};
        data[subject_name] = marks;
        this.setState(data);
    }

    get_subject_marks = (subject_name)=>{
        var data = this.state;
        var marks = data[subject_name];
        return marks;

    }



  render(){

    return(

  <Card small className="h-100" style={{margin:"5%"}}>
        <CardHeader className="border-bottom">
          <h6 className="m-0">Result</h6>
        </CardHeader>
        <CardBody className="pt-0">
          <ListGroup flush>
    <ListGroupItem className="p-3">
      <Row>
        <Col>
        {
          !this.state.loading && 
          <Form onSubmit={this.update_data}>        
           

            <FormGroup>
              <label htmlFor="feInputClassname" style={{color:'blue'}}>Name</label>
              <FormInput id="feInputAddress" value={this.state.name} disabled />
            </FormGroup>


            {
               
                  this.state.subjects.map((item,i)=>{
                            return (<Subject key={i} 
                                            sub_name={item.subjectname} 
                                            onChangeHandler={this.changeHandler}
                                            default_value={()=>{return (this.get_subject_marks(item.subjectname)) }}
                                            />
                                            
                                    )
                  })
            }

             { 
              
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

            }



            
            <Button type="submit">Modify Result</Button>
            
            <Button type="button" 
                    style={{marginLeft: '5%'}} 
                    theme="danger" 
                    onClick={this.props.cancel}>
                    Cancel
            </Button>
            
          </Form>
        }
        </Col>
      </Row>
    </ListGroupItem>
  </ListGroup>
        </CardBody>
      </Card>
        
    )
  }
}






class Subject extends Component{

    render(){

      var value = this.props.default_value();
      var default_value = (value===null)?"--":value;

      return(
      <div>
                <Col md="6">
                  <FormGroup>
                            <label htmlFor="feInputClassname" style={{color:'blue'}}>{this.props.sub_name}</label>
                            <FormInput placeholder="Marks Scored" defaultValue={default_value} onChange={(evt)=>{this.props.onChangeHandler(this.props.sub_name,evt.target.value)}}/>
                  </FormGroup>
                </Col>
            
          </div>
  )
    }
}